import { render, staticRenderFns } from "./FLoorForm.vue?vue&type=template&id=47302313&scoped=true"
import script from "./FLoorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FLoorForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FLoorForm.vue?vue&type=style&index=0&id=47302313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47302313",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
